// Main Layout Component - Provides consistent layout structure
// Adapted from AgentGroupChat component patterns and Revolt prototype

import { Header } from './Header';

export function MainLayout({ children, title, layoutClassName = '', contentClassName = '' }) {
  return (
    <div className={`main-layout ${layoutClassName}`.trim()}>
      {/* Shared Header */}
      <Header />

      {/* Main Content */}
      <main className={`${contentClassName} main-content`.trim()}>
        {children}
      </main>

      {/* Footer - Can be added later if needed */}
      {/* <footer className="footer">
        <div className="footer-content">
          <p>&copy; 2024 Revolt. Own Your AI.</p>
        </div>
      </footer> */}
    </div>
  );
}

// Higher-order component for sections that need layout
export function withLayout(WrappedComponent, layoutProps = {}) {
  return function WithLayoutComponent(props) {
    return (
      <MainLayout {...layoutProps}>
        <WrappedComponent {...props} />
      </MainLayout>
    );
  };
}
